(function () {
  'use strict';

  var incompleteScheduleText = 'Pay remaining amount on';

  function normaliseText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function repairDeferredPurchaseConsent() {
    var consent = document.querySelector('#shopify-buyer-consent[data-consent-type="subscription"]');

    if (!consent || consent.getAttribute('data-lgm-deferred-consent') === 'true') {
      return;
    }

    var policyButton = consent.querySelector('#shopify-subscription-policy-button');

    consent.textContent = 'This cart includes a preorder. By continuing, I agree to the ';

    if (policyButton) {
      policyButton.textContent = 'cancellation policy';
      consent.appendChild(policyButton);
    } else {
      var policyText = document.createTextNode('cancellation policy');
      consent.appendChild(policyText);
    }

    consent.appendChild(document.createTextNode(' and, where a balance remains, authorize its collection under the payment schedule shown above.'));
    consent.setAttribute('data-lgm-deferred-consent', 'true');
  }

  function repairDibsScheduleText() {
    var descriptions = document.querySelectorAll('.lb-ordereasy-payment-option-description');

    descriptions.forEach(function (description) {
      if (normaliseText(description.textContent) !== incompleteScheduleText) {
        return;
      }

      var option = description.closest('.lb-ordereasy-payment-option-text-content');
      var title = option ? option.querySelector('.lb-ordereasy-payment-option-title') : null;
      var amountMatch = title ? normaliseText(title.textContent).match(/^Partial payment\s*-\s*(.+)$/i) : null;
      var depositText = amountMatch ? amountMatch[1] + ' deposit today.' : 'Deposit due today.';

      description.textContent = depositText + ' Remaining balance due when your order is ready for dispatch.';
      description.setAttribute('data-lgm-dibs-schedule-fallback', 'true');
    });
  }

  function repairDibsAvailableVariantButton() {
    var productJson = document.querySelector('[id^="ProductJson-"]');
    var variantSelect = document.querySelector('select[name="id"]');
    var buttonText = document.querySelector('[id^="AddToCartText-"]');

    if (!productJson || !variantSelect || !buttonText) {
      return;
    }

    var product;

    try {
      product = JSON.parse(productJson.textContent);
    } catch (error) {
      return;
    }

    var selectedVariant = product.variants.find(function (variant) {
      return String(variant.id) === String(variantSelect.value);
    });

    if (!selectedVariant) {
      return;
    }

    var sellingPlanAllocations = selectedVariant.selling_plan_allocations || [];
    var currentButtonText = normaliseText(buttonText.textContent).toLowerCase();
    var hasStalePreorderLabel = currentButtonText === 'preorder' || currentButtonText === 'preorder now';

    var isOutOfStock = selectedVariant.inventory_management && selectedVariant.inventory_quantity <= 0;
    var isInStock = !isOutOfStock;

    if ((isInStock || sellingPlanAllocations.length === 0) && hasStalePreorderLabel) {
      var button = buttonText.closest('button');
      var status = document.querySelector('.lgm-product-status');
      var registerInterest = document.querySelector('.lgm-register-interest');

      if (isOutOfStock) {
        var isSampleSale = status && status.getAttribute('data-sample-sale') === 'true';
        buttonText.textContent = window.theme && window.theme.strings
          ? window.theme.strings.soldOut
          : 'Sold out';
        if (button) button.disabled = true;
        if (status) {
          status.textContent = isSampleSale
            ? 'This one-off sample pair has sold'
            : 'Currently unavailable - produced and restocked in limited runs';
        }
        if (registerInterest) registerInterest.classList.toggle('hide', isSampleSale);
      } else {
        buttonText.textContent = window.theme && window.theme.strings
          ? window.theme.strings.addToCart
          : 'Add to cart';
        if (button) button.disabled = false;
      }
      buttonText.setAttribute('data-lgm-dibs-button-fallback', 'true');
    }
  }

  function repairDibsPresentation() {
    repairDibsScheduleText();
    repairDibsAvailableVariantButton();
    repairDeferredPurchaseConsent();
  }

  function initialiseDibsScheduleFallback() {
    repairDibsPresentation();

    if (!window.MutationObserver) {
      return;
    }

    var observer = new MutationObserver(repairDibsPresentation);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function initialiseTaggedGalleries() {
    document.querySelectorAll('[data-lgm-tagged-gallery]').forEach(function (gallery) {
      var endpoint = gallery.getAttribute('data-feed-url');
      var grid = gallery.querySelector('[data-lgm-tagged-grid]');
      var limit = parseInt(gallery.getAttribute('data-limit'), 10) || 8;
      var modal = gallery.querySelector('[data-lgm-gallery-modal]');
      var player = gallery.querySelector('[data-lgm-gallery-player]');

      function youtubeFrame(id, preview) {
        var frame = document.createElement('iframe');
        var parameters = preview
          ? '?autoplay=1&mute=1&controls=0&loop=1&playlist=' + encodeURIComponent(id) + '&playsinline=1&modestbranding=1'
          : '?autoplay=1&controls=1&playsinline=1&rel=0';
        frame.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + parameters;
        frame.title = preview ? 'Muted video preview' : 'Archive video';
        frame.allow = 'autoplay; encrypted-media; picture-in-picture';
        frame.allowFullscreen = !preview;
        return frame;
      }

      function closeVideo() {
        if (!modal || !player) return;
        player.replaceChildren();
        modal.hidden = true;
        document.body.classList.remove('lgm-gallery-modal-open');
      }

      gallery.querySelectorAll('[data-lgm-gallery-close]').forEach(function (button) {
        button.addEventListener('click', closeVideo);
      });

      gallery.querySelectorAll('[data-lgm-gallery-video]').forEach(function (tile) {
        var id = tile.getAttribute('data-youtube-id');
        var preview;
        var timer;
        if (!id) return;

        tile.addEventListener('pointerenter', function () {
          if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
          timer = window.setTimeout(function () {
            if (tile.querySelector('iframe')) return;
            preview = youtubeFrame(id, true);
            tile.appendChild(preview);
          }, 180);
        });
        tile.addEventListener('pointerleave', function () {
          window.clearTimeout(timer);
          if (preview) preview.remove();
          preview = null;
        });
        tile.addEventListener('click', function () {
          window.clearTimeout(timer);
          if (preview) preview.remove();
          preview = null;
          if (!modal || !player) return;
          player.replaceChildren(youtubeFrame(id, false));
          modal.hidden = false;
          document.body.classList.add('lgm-gallery-modal-open');
        });
      });

      if (!endpoint || !grid) return;

      fetch(endpoint, { credentials: 'omit', mode: 'cors' })
        .then(function (response) {
          if (!response.ok) throw new Error('Tagged gallery unavailable');
          return response.json();
        })
        .then(function (payload) {
          var items = Array.isArray(payload.items) ? payload.items.slice(0, limit) : [];
          var fragment = document.createDocumentFragment();

          items.forEach(function (item) {
            if (!item || !item.image || !item.permalink) return;

            var link = document.createElement('a');
            var image = document.createElement('img');
            link.className = 'lgm-tagged-gallery__item';
            link.href = item.permalink;
            link.target = '_blank';
            link.rel = 'noopener noreferrer';
            link.setAttribute('aria-label', item.alt || 'View photographed work');
            image.src = item.image;
            image.alt = item.alt || '';
            image.loading = 'lazy';
            image.decoding = 'async';
            link.appendChild(image);
            fragment.appendChild(link);
          });

          if (fragment.childNodes.length) grid.appendChild(fragment);
        })
        .catch(function () {});
    });
  }

  function initialiseProductCardHoverMedia() {
    var mediaItems = Array.prototype.slice.call(document.querySelectorAll('[data-lgm-hover-media]'));
    var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var saveData = navigator.connection && navigator.connection.saveData;

    mediaItems.forEach(function (media) {
      var hoverImage = media.querySelector('.lgm-card-media__hover');
      if (!hoverImage) return;

      function markReady() {
        media.classList.add('lgm-card-media--ready');
      }

      if (hoverImage.complete && hoverImage.naturalWidth > 0) {
        markReady();
      } else {
        hoverImage.addEventListener('load', markReady, { once: true });
      }

      var video = media.querySelector('.lgm-card-media__video');
      var videoSource = media.getAttribute('data-lgm-card-video-src');
      var progress = media.querySelector('.lgm-card-media__loading-progress');

      if (!video || !videoSource || !finePointer || reducedMotion || saveData) return;

      var container = media.closest('.grid-view-item__image-container');
      var isActive = false;
      var enteredAt = 0;
      var playTimer = null;
      var flashSwapTimer = null;
      var flashEndTimer = null;
      var sourceAttached = false;
      var videoReady = false;

      function flashTransition(swap) {
        window.clearTimeout(flashSwapTimer);
        window.clearTimeout(flashEndTimer);
        media.classList.remove('lgm-card-media--flash');
        void media.offsetWidth;
        media.classList.add('lgm-card-media--flash');

        if (typeof swap === 'function') {
          flashSwapTimer = window.setTimeout(swap, 90);
        }

        flashEndTimer = window.setTimeout(function () {
          media.classList.remove('lgm-card-media--flash');
        }, 320);
      }

      function setProgress(value) {
        if (!progress) return;
        var bounded = Math.max(0.08, Math.min(1, value || 0));
        progress.style.transform = 'scaleX(' + bounded + ')';
      }

      function updateBufferedProgress() {
        if (!video.duration || !video.buffered.length) return;
        setProgress(video.buffered.end(video.buffered.length - 1) / video.duration);
      }

      function warmVideo() {
        if (sourceAttached) return;
        sourceAttached = true;
        video.src = videoSource;
        video.preload = 'auto';
        video.load();
      }

      function startVideo() {
        if (!isActive || !videoReady) return;
        video.currentTime = 0;
        var playResult = video.play();

        if (playResult && typeof playResult.then === 'function') {
          playResult.then(function () {
            if (isActive) {
              flashTransition(function () {
                if (isActive) media.classList.add('lgm-card-media--video-playing');
              });
            }
          }).catch(function () {
            media.classList.remove('lgm-card-media--video-playing');
          });
        } else {
          flashTransition(function () {
            if (isActive) media.classList.add('lgm-card-media--video-playing');
          });
        }
      }

      function scheduleVideo() {
        if (!isActive || !videoReady) return;
        window.clearTimeout(playTimer);
        playTimer = window.setTimeout(startVideo, Math.max(0, 500 - (performance.now() - enteredAt)));
      }

      function markVideoReady() {
        if (videoReady) return;
        videoReady = true;
        setProgress(1);
        media.classList.add('lgm-card-media--video-ready');
        scheduleVideo();
      }

      function activate() {
        isActive = true;
        enteredAt = performance.now();
        media.classList.add('lgm-card-media--active');
        flashTransition();
        warmVideo();
        scheduleVideo();
      }

      function deactivate() {
        isActive = false;
        window.clearTimeout(playTimer);
        flashTransition(function () {
          media.classList.remove('lgm-card-media--active', 'lgm-card-media--video-playing');
          video.pause();
          try { video.currentTime = 0; } catch (error) {}
        });
      }

      video.addEventListener('progress', updateBufferedProgress);
      video.addEventListener('loadedmetadata', updateBufferedProgress);
      video.addEventListener('canplay', markVideoReady, { once: true });
      video.addEventListener('error', function () {
        media.classList.remove('lgm-card-media--video-ready', 'lgm-card-media--video-playing');
      });
      video.addEventListener('contextmenu', function (event) { event.preventDefault(); });

      if (container) {
        container.addEventListener('pointerenter', activate);
        container.addEventListener('pointerleave', deactivate);
      }

      media.lgmWarmVideo = warmVideo;
    });

    if (!finePointer || reducedMotion || saveData) return;

    function warmHomepageVideos() {
      var ordered = mediaItems.slice().sort(function (a, b) {
        var aVisible = a.getBoundingClientRect().top < window.innerHeight ? 0 : 1;
        var bVisible = b.getBoundingClientRect().top < window.innerHeight ? 0 : 1;
        return aVisible - bVisible;
      });

      ordered.forEach(function (media, index) {
        window.setTimeout(function () {
          if (typeof media.lgmWarmVideo === 'function') media.lgmWarmVideo();
        }, index * 350);
      });
    }

    function scheduleWarmup() {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(warmHomepageVideos, { timeout: 1600 });
      } else {
        window.setTimeout(warmHomepageVideos, 600);
      }
    }

    if (document.readyState === 'complete') scheduleWarmup();
    else window.addEventListener('load', scheduleWarmup, { once: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseDibsScheduleFallback);
    document.addEventListener('DOMContentLoaded', initialiseTaggedGalleries);
    document.addEventListener('DOMContentLoaded', initialiseProductCardHoverMedia);
  } else {
    initialiseDibsScheduleFallback();
    initialiseTaggedGalleries();
    initialiseProductCardHoverMedia();
  }
})();
